<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">{{ stepOneTitle }}</div>

        <Subject :statement="statement" :subject="statement.subjects.applicant" />
      </v-col>
    </v-row>

    <v-row
      v-if="
        statement.rodStep2 &&
        statement.rodStep2.proxies &&
        statement.rodStep2.proxies.length
      "
    >
      <v-col cols="12">
        <div class="form-base__title step-name">Список доверенностей</div>
        <div>
          <Step2 :data="statement.rodStep2.proxies" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from "@/components/elements/statement/FullStatementView/elements/Subject";
import Step2 from '@/components/elements/statement/FullStatementView/steps/ROD/Step2';
import { StatementType } from '@/types/services';
import { ApplicantRoleConst } from '@/constants';

export default {
  name: 'ROD',
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  components: {
    Subject,
    Step2,
  },
  data: () => ({
    StatementType,
  }),
  computed: {
    stepOneTitle() {
      return this.statement.applicantRole === ApplicantRoleConst.TRUSTEE
        ? 'Сведения о доверенности в машиночитаемом виде'
        : 'Сведения о заявителе';
    },
  },
};
</script>

<style scoped></style>
